<template lang="html">
  <div class="d-flex" v-if="currentDataChart">
    <div id="chart" class="m-auto"  >
      <apexchart v-if="currentDataChart" :key="uniqueId" type="pie" width="620" :options="chartOptions" :series="series" ></apexchart>
    </div>
  </div>
</template>

<script>


export default {
  props: ['showAmountNotNumber', 'datasetData'],
  data () {
    return {
      series: [],
      chartOptions: {
        labels: [],
        colors: [],
      },
      backgroundColors: {
        "RTPI-001": '#ff0000',
        "RTPI-002": '#ff00c1',
        "RTPI-003": '#ffad00',
        "RTPI-004": '#e1e100',
        "RTPI-005": '#73ff00',
        "RTPI-006": '#3bb705',
        "RTPI-007": '#00ffd7',
        "RTPI-008": '#006fff',
        "RTPI-009": '#752ae3',
        "RTPI-010": '#6f3503',
        "RTPI-011": '#4b4a4b',
        "OTHER": "#cccccc"
      },
      RTPIData: this.datasetData,
      uniqueId: this.generateUniqueId(),
      currentDataChart: false,
    }
  },
  created () {
    this.makeChartData(this.datasetData)
    this.currentDataChart = true
  },
  mounted() {
    this.makeChartData(this.datasetData)
    this.currentDataChart = true
  },
  watch: {
    datasetData: {
      handler (newValue) {
        this.makeChartData(newValue)
        this.currentDataChart = true
      }
    },
  },
  methods: {
    generateUniqueId() {
      return 'id-' + Math.random().toString(36).substr(2, 9);
    },
    makeChartData (rawData) {
      this.uniqueId = this.generateUniqueId()
      this.currentDataChart = false
      this.chartOptions.labels = []
      this.chartOptions.colors = []
      let data = []
      Object.keys(rawData).forEach(key => {
        this.chartOptions.colors.push(this.backgroundColors[key])
        this.chartOptions.labels.push(this.$t('filter.feature.'+key))
        data.push(rawData[key])
      })
      this.series = data
      return data
    }
  }
}
</script>
<style>
.chartjs-tooltip {
  z-index: 99999999 !important; /* Force un z-index élevé */
  position: absolute;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  padding: 5px;
  font-size: 12px;
  text-align: center;
}
</style>
